<template>
<div class="tile" :class="[inactive?'tilegrey':'tilecolor', inactive || done?'':'clickable mediumShadow']"
     :style="styleObject"
     @mouseover="hoverenter"
     @mouseleave="hoverleave"
     @click="click"
    :title="inactive?alt:''">
    <div class="tile--body flexwrap centercenter" :class="[inactive || done?'':'active']" :key="hover"  v-if="hover || completed || !inactive">
        <span><slot name="description" ></slot></span>
      <span v-if="earn!=0" :class="[inactive?'tilePointsGrey':'tilePoints']">+{{earn}}pts</span>
      <div v-if="premium && !inactive && !this.profile.datas.is_premium" class="premiumButton flexwrap centercenter">
        <i class="fas fa-burn"></i>
      </div>
    </div>
    <div class="tile--body--title" :class="[inactive?'tilePointsGrey':'tileplaincolor']">
      <div class="tile--title flexwrap">
        <!--<span v-if="!completed && isMobile" style="font-size: 0.75em"><slot name="title"></slot></span>-->
        <i class="fas" :class="icon" style="font-size: 0.9em"></i>
        <transition name="fadetile" mode="out-in" appear>
          <span v-if="hovert || !inactive">&nbsp;<slot name="title"></slot></span>
        </transition>
      </div>

      <div v-if="completed" class="tile--check">
        <div class="flexwrap" style="width: 4vw; justify-content: flex-end; border-radius: 1vw; overflow: hidden">
          <i class="fas fa-check-circle" style="z-index: 3; position:absolute; "></i>
          <transition name="slide-fade" mode="out-in" appear>
            <div v-if="hover && completed" :key="hover" style="font-size: 0.75em; padding: 0 1.25vw 0 0.25vw; border-radius: 1vw; background-color: #02020255;">{{points}}pts</div>
          </transition>

        </div>

      </div>
    </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "tile",
  props:['premium', 'inactive', 'completed','color1', 'color2', 'icon', 'points', 'earn', 'done', 'alt'],
  methods:{
    click: function(){
      if(!this.inactive){
        if(this.premium && !(this.profile.datas.is_premium || this.profile.datas.trial_days_left > 0)){
          this.$router.push({name:'premium'})
        }
        else{
          this.$emit('click')
        }
      }

    },
    hoverenter: function (){
      this.hover = true
      window.setTimeout(() => {
        this.hovert = true
      }, 200)
    },
    hoverleave: function (){
      window.setTimeout(() => {
        this.hovert = false
      }, 200)
      window.setTimeout(() => {
        this.hover = false
      }, 250)
    },
    greyify: function (color){
      let components = color.slice(1).match(/.{1,2}/g);

      let r = parseInt(components[0], 16)
      let g = parseInt(components[1], 16)
      let b = parseInt(components[2], 16)
      let gr = Math.floor(r + (g+b)/2.5 - (r+g+b)*2/7.5)
      let gg = Math.floor(g + (r+b)/2.5 - (r+g+b)*2/7.5)
      let gb = Math.floor(b + (r+g)/2.5 - (r+g+b)*2/7.5)

      return "#" + gr.toString(16) + gg.toString(16) + gb.toString(16);

    }
  },
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'profile',
    ]),
    styleObject: function () {
      let fw = '2em'
      let ai = 'center'
      let color1 = this.color1
      let color2 = this.color2

      let colorgrey = this.greyify(color2)


      let titleheight = 'calc(100%)'
      if(this.isMobile){
        titleheight = 'calc(100% - 3vw)'
      }
      if(this.hover || this.completed || !this.inactive){
        fw =  '1.1em'
        ai = 'flex-start'

        if(this.isMobile){
          titleheight = '4.5vw'
        }
        else{
          titleheight = '2.1vw'
        }

      }
      return {
        '--fw': fw,
        '--ai': ai,
        '--color1': color1,
        '--color2': color2,
        '--colorgrey': colorgrey+'10',
        '--colorgrey2': colorgrey+'33',
        '--title-height': titleheight
      }
    },
  },
    data() {
      return {
        hover: false,
        hovert: false,
      }

  }
}
</script>

<style scoped>
  .tile {
    border-radius: 1.2vw;
    overflow: hidden;
    height: 100%;
    width: 12vw;
    display: grid;
    grid-template-rows: 1fr auto;
    align-items: center;
    color: var(--lightColor);
    position: relative;
  }

  .tilecompleted {
    height: 91.66%;
    width: 11vw;
  }

  .tilePoints{
    font-size: 0.9em;
    padding: 0.12vw 0.25vw 0.12vw 0.25vw;
    background-color: #02020250;
    border-radius: 2vw;
  }

  .tiletopPoints{
    font-size: 0.8em;
    background-color: #02020250;
    border-radius: 2vw;
  }

  .tilePointsGrey{
    font-size: 1em;
    padding: 0.12vw 0.25vw 0.12vw 0.25vw;
    background-color: var(--colorgrey);
    border-radius: 2vw;
  }

  .tile--title{
    font-size: var(--fw);
    font-weight: bold;
    text-align: center;
    justify-content: var(--ai);
    align-items: center;
    align-content: center;
    height: 100%;
    transition: all 0.1s;
  }
  .tile--body{
    height: calc(100% - 1vw - var(--title-height));
    /*font-size: 0.87em;*/
    border-radius: 1.2vw;
    padding: calc(0.5vw + var(--title-height)) 0.5vw 0.5vw 0.5vw;
    text-align: center;
    display: grid;
    grid-template-rows: 1fr auto;
  }
  .tile--body--title{
    position: absolute;
    height: var(--title-height);
    width: calc(100% - 2vw);
    font-size: 1.1em;
    font-weight: bold;
    padding: 0 1vw 0 1vw;
    top: 0;
    border-radius: 1.2vw 1.2vw 0 0;
    transition: all 0.2s;
    align-items: center;
    align-content: center;
  }
  .tilegrey{
    background-color: var(--colorgrey2);
  }
  .tilecolor{
    background-color: var(--color2);
  }
  .tileplaincolor{
    background-color: var(--color1);
  }
  .tiledarkcolor{
    background-color: var(--color2);
    border-bottom: 1px solid #ffffff33;
  }
  .tile--check{
    position: absolute;
    top: 0.5vw;
    right: 0.5vw;
  }
  .active:hover{
    background-color: #00000022;
  }



  .premiumButton{
    position: absolute;
    bottom: 0.5vw;
    right: 0.5vw;
    border-radius: 2vw;
    height: 1.2vw;
    width: 1.2vw;
    font-size: 0.55vw;
    color: #ffda7b;
    background-color: hsla(200, 20%, 10%,0.9);
  }


  .fadetile-enter /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .fadetile-enter-active {
    transition: all .2s;
    -webkit-transition: all .2s;
    -ms-transition: all .2s;
  }


  @media screen and (max-device-width: 767px) {
    .tile {
      width: 39vw;
      border-radius: 4vw;
      min-height: 32vw;
      height: fit-content;
    }

    .tilePoints{
      padding: 0.5vw 1.5vw 0.5vw 1.5vw;
      background-color: #02020266;
      border-radius: 5vw;
      margin-bottom: 0.5vw;
    }

    .tile--check{
      top: 2vw;
      right: 2vw;
    }
    .tile--body--title{
      padding: 1.5vw 3vw 1.5vw 3vw;
      width: calc(100% - 6vw);
    }

    .tile--body{
      height: calc(100% - 7vw - var(--title-height));
      padding: calc(5.5vw + var(--title-height)) 0.5vw 1.5vw 0.5vw;
    }

    .premiumButton{
      position: absolute;
      bottom: 1.2vw;
      right: 1.2vw;
      border-radius: 8vw;
      height: 4.5vw;
      width: 4.5vw;
      font-size: 2vw;
    }
  }
</style>